import { createGlobalStyle } from "styled-components";

const Layout = createGlobalStyle`
  .FullBleed {
    width: 100vw;
    margin-left: calc(50% - 50vw);
  }

  .Content {
    max-width: calc(1240px + 2 * 40px);
    margin-left: auto;
    margin-right: auto;
    padding-left: 40px;
    padding-right: 40px;
  }

  @media(max-width: ${({ theme }) => `${theme.breakpoints.xl}px`}) {
    .Content {
      padding-left: 32px;
      padding-right: 32px;
    }

    .xl\\:FullBleed {
      width: 100vw;
      margin-left: calc(50% - 50vw);
    }
  }

  @media(max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    .lg\\:FullBleed {
      width: 100vw;
      margin-left: calc(50% - 50vw);
    }
  }

  @media(max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    .Content {
      padding-left: 24px;
      padding-right: 24px;
    }

    .md\\:FullBleed {
      width: 100vw;
      margin-left: calc(50% - 50vw);
    }
  }

  @media(max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    .sm\\:FullBleed {
      width: 100vw;
      margin-left: calc(50% - 50vw);
    }
  }
`;

export { Layout };
